<template>
  <a-layout 
    class="modal" 
    :size="size"
    overlay 
    wrapper 
    center
  >
    <div class="box --modal">
      <div class="box__header">
        <div class="title d--flex align-items--center ">
          <a-icon
            v-if="icon"
            :name="icon"
            :class="`text--${iconColor} me--2`"
            :width="28"
            :height="28"
          />
          <h2>{{ title }}</h2>
        </div>
        <a-button
          v-if="closable"
          variant="reset" 
          @click="$emit('close')"
        >
          <a-icon name="close" />
        </a-button>
      </div>
      <div class="box__content">
        <slot />
      </div>
      <div class="box__footer">
        <slot name="footer" />
      </div>
    </div>
  </a-layout>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/stores'

const props = defineProps({
  closable: {
    type: Boolean,
    default: true
  },
  title: {
    type: String
  },
  size: {
    type: String,
    default: 'base',
    validator: (value) => ['base', 'wide', 'x-wide', 'xx-wide'].includes(value)
  },
  icon: {
    type: String,
    default: ''
  },
  iconColor: {
    type: String,
    default: 'warning' // 'warning', 'danger', 'success', 'info'
  }
})
</script>


<style lang="scss">
.modal {
  background-color: $backdrop;
  z-index: $zindex-modal;
}

.title {
  width: 90%;
}
</style>
